import React from "react";

import ChartWithTable from "@Components/shared/ChartWithTable";
import GroupedRadialBarChart, { IGroupedRadialBarChartData } from "@Components/shared/GroupedRadialBarChart";
import { pluralise } from "@Utils";
import { Col, Row, Typography } from "antd";

const { Title } = Typography;

interface IProps {
    pointsData: { chartData: IGroupedRadialBarChartData[]; tableData: Record<string, unknown[]> };
}

/**
 * The column data for the CPD Chart
 */
const CHART_COLUMN_DATA = [{ key: "activity" }, { key: "date" }, { key: "duration" }];

const CPDChart = ({ pointsData }: IProps) => {
    return (
        <Row>
            <Col xs={24}>
                <Title level={3} style={{ width: "100%" }}>
                    CPD Points
                </Title>
                <span style={{ marginBottom: "30px", display: "block" }}>Points for each activity type</span>
            </Col>
            <Col xs={24}>
                <ChartWithTable
                    chart={GroupedRadialBarChart}
                    columnData={CHART_COLUMN_DATA}
                    data={pointsData}
                    suffix={(quantity: number) => `CPD ${pluralise("Point", quantity)}`}
                    valueLabel="Total"
                />
            </Col>
        </Row>
    );
};

export default CPDChart;
